module.exports = __webpack_public_path__ + "img/icon_sm_yfzk.42aafc18.png";